import { ApiProperty } from '../codegen';
import { IsIn, IsOptional, IsString } from '../validators';

export const ROUTE_COLOR_VALUES = ['blue', 'green'] as const;
export type TRouteColor = (typeof ROUTE_COLOR_VALUES)[number];

export class WsTicketQueryDto {
  @ApiProperty({ required: false })
  @IsOptional()
  @IsIn(ROUTE_COLOR_VALUES as unknown as string[])
  routeColor?: TRouteColor;
}

/**
 * DTO for WebSocket ticket response.
 * Used for WebSocket connection authorization.
 */
export class WsTicketReturnDto {
  @ApiProperty({
    description: 'One-time ticket for WebSocket authentication',
    example: '550e8400-e29b-41d4-a716-446655440000',
  })
  @IsString()
  ticket: string;
}
